// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XB6D7","colBig":"styles_colBig__1GRLP","colSmall":"styles_colSmall__8449E"};